<style lang="less" scoped>
    .modal {
        /deep/.ivu-modal-body {
            min-height: 0;
        }
    }
</style>
<template>
  <div>
    <Modal
      v-model="showModal"
      class="modal"
      :title="title"
      :closable="false"
    >
      <div>
        <Form
          ref="formValidate" 
          :model="formItem"
          :label-width="80"
        >
          <FormItem 
            prop="examine_remark"
            label="备注"
            :rules="[{ required: true, message: '备注不能为空', trigger: 'blur' }]"
          >
            <Input
              v-model="formItem.examine_remark"
              type="textarea"
              :autosize="{minRows: 2,maxRows: 5}"
              placeholder="请输入"
            />
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button
          @click="cancel"
        >
          取消
        </Button>
        <Button
          type="primary"
          :loading="loading"
          @click="ok"
        >
          确定
        </Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  export default {
    props: {
      display: {
        type: Number,
        default:() => null
      },
      formProps: {
        type:Object,
        default:() => ({})
      },
      loading:{
        type:Boolean,
        default:() => false
      }
    },
    data() {
      return {
        showModal: false,
        title: '',
        formItem: {
          examine_remark: ''
        }
      }
    },
    watch: {
      display(value) {
        switch (value) {
        case 2:
          this.title = 'HOLD'
          this.showModal = true
          this.formItem.examine_remark = this.formProps.examine_remark
          break;
        case 3:
          this.title = '废弃'
          this.showModal = true
          this.formItem.examine_remark = this.formProps.examine_remark
          break;
        default:
          break;
        }
           
      }
    },
    methods: {
      ok() {
        this.$refs.formValidate.validate((valid) => {
          const { id } = this.formProps
          const { examine_remark } = this.formItem
          if (valid) {
            this.$emit('ok', { status:this.display, id, examine_remark, call:() => {this.showModal = false} }) 
          }
        })
      },
      cancel() {
        this.showModal = false
        this.$emit('cancel')
      }
    }
  }
</script>
